import { Component, OnInit } from '@angular/core';
import { DataTransferServiceService } from '../services/data-transfer-service.service';

@Component({
  selector: 'app-terms-and-condition',
  templateUrl: './terms-and-condition.component.html',
  styleUrls: ['./terms-and-condition.component.css']
})
export class TermsAndConditionComponent implements OnInit {

  constructor(
    private dataTransferService: DataTransferServiceService,

  ) { }

  ngOnInit(): void {
    const currentUrl = window.location.href; 
    this.dataTransferService.logPageVisitByIp(currentUrl);

  }

}
